import React from "react";
import { Box, Grid, IconButton, Modal, Stack, Typography } from "@mui/material";
import { CalendarMonthOutlined, Close } from "@mui/icons-material";
import { colors } from "../../theme/theme";

const PostViewerModal = ({ open, onClose, post }) => {
  if (!post) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.9)",
          overflow: "auto",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ p: 2, position: "sticky", top: 0, backgroundColor: "rgba(0,0,0,0.9)" }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-SemiBold",
              fontSize: "16px",
            }}
          >
            {post.title}
          </Typography>
          <IconButton onClick={onClose}>
            <Close sx={{ color: "#fff" }} />
          </IconButton>
        </Stack>

        <Box sx={{ maxWidth: "700px", mx: "auto", p: { xs: 2, md: 3 }, pb: 6 }}>
          <Box
            component="img"
            src={post.images?.[0]?.image_url}
            alt={post.title}
            sx={{
              width: "100%",
              height: { xs: "220px", md: "360px" },
              objectFit: "cover",
              borderRadius: "14px",
              display: "block",
            }}
          />

          <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2, mb: 1 }}>
            <CalendarMonthOutlined
              sx={{ color: colors.secondary, fontSize: "18px" }}
            />
            <Typography
              sx={{
                color: "rgba(255,255,255,0.7)",
                fontFamily: "Mulish-Regular",
                fontSize: "13px",
              }}
            >
              {post.date}
            </Typography>
          </Stack>

          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-ExtraBold",
              fontSize: "24px",
              mb: 1,
            }}
          >
            {post.title}
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.75)",
              fontFamily: "Mulish-Regular",
              fontSize: "14px",
              mb: 3,
            }}
          >
            {post.content}
          </Typography>

          {post.images?.length > 1 && (
            <Grid container spacing={1.5}>
              {post.images.slice(1).map((image, index) => (
                <Grid item size={{ xs: 6, sm: 4, md: 3 }} key={index}>
                  <Box
                    component="img"
                    src={image.image_url}
                    alt={`${post.title}-${index}`}
                    sx={{
                      width: "100%",
                      height: "120px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      display: "block",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default PostViewerModal;
